import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import BadgeHighlight from '../../BadgeHighlight';

import './index.css';

const linkType = {
  to: PropTypes.string,
  label: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

const propTypes = {
  ...linkType,
  icon: PropTypes.node.isRequired,
  isExternal: PropTypes.bool,
  shouldHighlight: PropTypes.bool,
  collapseSubMenus: PropTypes.bool.isRequired,
  subLinks: PropTypes.arrayOf(PropTypes.shape(linkType)),
};

const defaultProps = {
  subLinks: [],
  isExternal: false,
  shouldHighlight: false,
};

class NavLink extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubMenuOpened: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { collapseSubMenus } = this.props;
    if (nextProps.collapseSubMenus && !collapseSubMenus) {
      this.setState({
        isSubMenuOpened: false,
      });
    }
  }

  componentDidMount() {
    this.setSubLinkListHeight();
  }

  componentDidUpdate(prevProps) {
    const { subLinks } = this.props;
    if (subLinks.length !== prevProps.subLinks.length) {
      this.setSubLinkListHeight();
    }
  }

  setSubLinkListHeight = () => {
    const { subLinks } = this.props;

    if (subLinks && subLinks.length) {
      const navLinkHeight = this.navLink.offsetHeight;
      const subLinksListHeight = this.subLinksList.offsetHeight;
      const navLinkTargetHeight = navLinkHeight + subLinksListHeight;

      this.navLink.style.height = `${navLinkTargetHeight}px`;
    }
  };

  handleRef = refName => {
    return ref => {
      this[refName] = ref;
    };
  };

  renderSubLinkList = subLinks => {
    const subLinksToItems = subLink => {
      const { label, to, isActive, key, onClick, isSuspended, isBlocked } = subLink;
      const linkClass = classNames('NavLink__sub_link', {
        'NavLink__sub_link--active': isActive,
      });

      return (
        <li className={linkClass} key={key}>
          <Link
            onClick={onClick}
            to={to}
            className="NavLink__anchor NavLink__anchor_shops u__normalize_anchor"
          >
            <div className="NavLink__sub_link_text">{label}</div>
            {isSuspended && (
              <div className="NavLink__notification_suspended">
                <FormattedMessage id="dealer_suspended" defaultMessage="SUSPENDED" />
              </div>
            )}
            {isBlocked && (
              <div className="NavLink__notification_blocked">
                <FormattedMessage id="dealer_blocked" defaultMessage="BLOCKED" />
              </div>
            )}
          </Link>
        </li>
      );
    };

    if (subLinks.length) {
      return (
        <ul ref={this.handleRef('subLinksList')} className="SideBar__list">
          {subLinks.map(subLinksToItems)}
        </ul>
      );
    }

    return null;
  };

  toggleSubMenu = () => {
    const { subLinks } = this.props;

    if (subLinks && subLinks.length) {
      this.setState(prevState => ({
        isSubMenuOpened: !prevState.isSubMenuOpened,
      }));
    }
  };

  render() {
    const {
      isActive,
      to,
      icon,
      label,
      subLinks,
      isExternal,
      shouldHighlight,
      onClick,
    } = this.props;
    const { isSubMenuOpened } = this.state;
    const linkClass = classNames('NavLink', {
      'is-active': isActive,
      'is-collapsed': !isSubMenuOpened,
    });

    if (isExternal) {
      return (
        <BadgeHighlight isOff={!shouldHighlight} className={linkClass}>
          <a
            onClick={onClick}
            ref={this.handleRef('navLink')}
            className="NavLink__anchor u__normalize_anchor"
            href={to}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="NavLink__icon">{icon}</span>
            <span className="NavLink__text">{label}</span>
          </a>
        </BadgeHighlight>
      );
    }

    return (
      <BadgeHighlight isOff={!shouldHighlight} className={linkClass}>
        <div ref={this.handleRef('navLink')} onClick={onClick}>
          <Link
            onClick={this.toggleSubMenu}
            to={to}
            className="NavLink__anchor u__normalize_anchor"
          >
            <span className="NavLink__icon">{icon}</span>
            <span className="NavLink__text">{label}</span>
            {subLinks.length > 0 && <div className="NavLink__triangle" />}
          </Link>
          {this.renderSubLinkList(subLinks)}
        </div>
      </BadgeHighlight>
    );
  }
}

NavLink.propTypes = propTypes;
NavLink.defaultProps = defaultProps;

export default NavLink;



// WEBPACK FOOTER //
// ../ui-components/components/SideBar/NavLink/index.jsx